import React, { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import FounderLetter from "@/components/FounderLetter";

/**
 * /letter — the canonical, shareable URL for the founder's letter.
 * Owns its own <head> meta tags so social share cards are rich.
 */
export default function FounderLetterPage() {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = "A note from the founder · Bidorah";
    const ensureMeta = (selector, attrs) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
        document.head.appendChild(el);
      } else {
        Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
      }
      return el;
    };

    const description =
      "Bidorah is being built by one person. U.S. ID-verified sellers, strict wholesale gating, escrow-backed payouts — built so you can spend $5 or $5,000 with the same confidence. Read the founder's letter.";

    const created = [
      ensureMeta('meta[name="description"]', {
        name: "description",
        content: description,
      }),
      ensureMeta('meta[property="og:title"]', {
        property: "og:title",
        content: "A note from the founder · Bidorah",
      }),
      ensureMeta('meta[property="og:description"]', {
        property: "og:description",
        content: description,
      }),
      ensureMeta('meta[property="og:type"]', {
        property: "og:type",
        content: "article",
      }),
      ensureMeta('meta[name="twitter:card"]', {
        name: "twitter:card",
        content: "summary_large_image",
      }),
      ensureMeta('meta[name="twitter:title"]', {
        name: "twitter:title",
        content: "A note from the founder · Bidorah",
      }),
      ensureMeta('meta[name="twitter:description"]', {
        name: "twitter:description",
        content: description,
      }),
    ];

    return () => {
      document.title = prevTitle;
      // We deliberately leave the meta tags in place — react-router
      // navigation isn't a fresh page load, so removing them would
      // briefly flash a stale title in the next route's social-card
      // probe (rare but possible). Subsequent route mounts will
      // overwrite these values via their own useEffects.
      void created;
    };
  }, []);

  return (
    <div className="min-h-screen bg-white" data-testid="founder-letter-page">
      <Navbar />
      <main>
        <FounderLetter variant="full" />
      </main>
      <Footer />
    </div>
  );
}
